import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { SectionHeading } from "../SectionHeading";

const FEATURED = [
  {
    tag: "Lumber",
    title: "Dimensional & Engineered Lumber",
    img: "/media/photos/lumber-bundled.jpg",
    to: "/services#lumber",
    testId: "featured-lumber",
  },
  {
    tag: "Structural Steel",
    title: "Structural Steel & Fabrication",
    img: "/media/photos/steel-framework.jpg",
    to: "/services#steel",
    testId: "featured-steel",
  },
];

const FeaturedCard = ({ tag, title, img, to, testId }) => (
  <Link
    to={to}
    data-testid={testId}
    className="group relative block overflow-hidden bg-[#0A192F] aspect-[4/5] md:aspect-[3/4]"
  >
    <img
      src={img}
      alt={title}
      loading="lazy"
      className="absolute inset-0 w-full h-full object-cover opacity-70 group-hover:opacity-50 group-hover:scale-105 transition-all duration-700"
    />
    <div className="absolute inset-0 bg-gradient-to-t from-[#0A192F] via-[#0A192F]/40 to-transparent" />
    <div className="relative h-full flex flex-col justify-end p-6 sm:p-8 lg:p-10 text-white">
      <span className="font-display text-[11px] uppercase tracking-[0.3em] text-[#D4AF37]">
        {tag}
      </span>
      <h3 className="mt-3 font-display font-black text-2xl sm:text-3xl lg:text-4xl">{title}</h3>
      <div className="mt-6 sm:mt-8 inline-flex items-center gap-3 font-display text-xs uppercase tracking-[0.3em] text-[#D4AF37] group-hover:gap-5 transition-all">
        Learn More <ArrowRight size={16} />
      </div>
    </div>
  </Link>
);

export const FeaturedServicesSection = () => (
  <section
    className="py-20 sm:py-24 lg:py-32 bg-[#F0F4F8]"
    data-testid="home-featured-services"
  >
    <div className="max-w-7xl mx-auto px-5 sm:px-6 lg:px-10">
      <SectionHeading
        eyebrow="Featured Material Supply"
        title="Two specialties. One standard."
      />
      <div className="mt-12 sm:mt-16 grid md:grid-cols-2 gap-5 sm:gap-6">
        {FEATURED.map((s) => (
          <FeaturedCard key={s.title} {...s} />
        ))}
      </div>
    </div>
  </section>
);

export default FeaturedServicesSection;
